  <!-- Header -->
  <vex-page-layout-header class="pb-16" fxLayout="column" fxLayoutAlign="center start" style="background-color: #f1f5f9;">
    <div [class.container]="layoutCtrl.value === 'boxed'"
          [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
          class="w-full flex flex-col sm:flex-row justify-between">
      <div>
        <div class="flex flex-col min-w-0 ml-4">
          <ng-container *transloco="let t">
            <div class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate" style="color: #4B4F55;" >
              {{headerText}}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </vex-page-layout-header>
